import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BLE } from '@ionic-native/ble/ngx';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginComponent } from './components/login/login.component';
import { BASE_PATH } from 'src/generated_client';
import { environment } from 'src/environments/environment';
import { MyAccountComponent } from './components/my-account/my-account.component';
import { ArticlesMenuComponent } from './components/articles-menu/articles-menu.component';
import { OrderDetailComponent } from './components/order-detail/order-detail.component';
import { OrderSummaryComponent } from './components/order-summary/order-summary.component';
import { TokenInterceptorService } from './services/auth/token-interceptor.service';
import { ChangeStatusPipe } from './pipes/change-status.pipe';
import { PopoverOrderConfirmComponent } from './components/popover-order-confirm/popover-order-confirm.component';
import { OrdersHistoryComponent } from './components/orders-history/orders-history.component';
import { PipesModule } from './pipes/pipes.module';
import { PopoverOrderRejectComponent } from './components/popover-order-reject/popover-order-reject.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    MyAccountComponent,
    ArticlesMenuComponent,
    OrderDetailComponent,
    OrderSummaryComponent,
    ArticlesMenuComponent,
    ChangeStatusPipe,
    PopoverOrderConfirmComponent,
    PopoverOrderRejectComponent,
    OrdersHistoryComponent
  ],
  entryComponents: [],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    PipesModule,
  ],
  providers: [
    ChangeStatusPipe,
    BLE,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: BASE_PATH, useValue: environment.apiBaseUrl },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptorService, multi: true },],
  bootstrap: [AppComponent],

})
export class AppModule { }
